import React from 'react';
import { Check } from 'lucide-react';

interface RadioOptionProps {
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
  rightText?: string;
  className?: string;
  disabled?: boolean;
}

/**
 * Radio-style selection option with checkmark indicator.
 * Reusable across campaign flow steps for consistent selection UI.
 */
export const RadioOption: React.FC<RadioOptionProps> = ({
  selected,
  onClick,
  children,
  rightText,
  className = '',
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg border text-left transition-all ${
        selected
          ? 'border-gray-800 bg-gray-50'
          : 'border-gray-200 bg-white hover:border-gray-300'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      <div
        className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
          selected ? 'border-gray-800 bg-gray-800' : 'border-gray-300'
        }`}
      >
        {selected && <Check className="w-2.5 h-2.5 text-white" />}
      </div>
      <span className="text-[13px] text-gray-800 flex-1">{children}</span>
      {rightText && (
        <span className="text-[12px] text-gray-400">{rightText}</span>
      )}
    </button>
  );
};

RadioOption.displayName = 'RadioOption';
